"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroundFillsV0RuleSheet = exports.NetTypeAutoLayoutPrioritySheet = exports.ImpedanceRuleSheet = exports.DefaultRuleSheet = void 0;
const auto_layout_1 = require("../../auto_layout");
const constants_1 = require("./constants");
const layout_1 = require("./layout");
exports.DefaultRuleSheet = {
    element: {
        position: layout_1.SystemPcbLayoutRulesValues.auto,
        keepOut: "element(0.5mm)",
    },
    routeSegment: {
        startPosition: "-5mm 0",
        endPosition: "5mm 0",
        minSizeY: "0.15mm",
        minKeepOut: "net(0.5mm) polygon(0.5mm)",
        solderMaskExpansion: undefined,
        traceCornerRadiusMinimum: "500um",
    },
    rectangle: {
        startPosition: "-5mm 5mm",
        endPosition: "5mm -5mm",
    },
    line: {
        startPosition: "-5mm 0",
        endPosition: "5mm 0",
    },
    circle: {
        size: "5mm",
    },
    layout: {
        size: "16cm 10cm",
        minSizeX: "5mm",
        minSizeY: "6mm",
        maxSizeX: "500mm",
        maxSizeY: "1100mm",
        boardInsetMargin: "400um",
        stackup: constants_1.DEFAULT_LAYOUT_STACKUP_KEY,
    },
    pad: {
        size: "1.6mm",
        minSizeX: "0.15mm",
        minSizeY: "0.15mm",
        solderMaskExpansion: "0",
        holeSize: "0.7mm",
        minHoleSize: "0.2mm",
        maxHoleSize: "6.3mm",
        connectedLayers: "All",
        minKeepOut: "net(0.5mm) polygon(0.5mm)",
    },
    zone: {
        size: "8mm 4mm",
        connectedLayers: "All",
    },
    via: {
        size: constants_1.DEFAULT_VIA_SIZE,
        minSizeX: "0.4mm",
        minSizeY: "0.4mm",
        solderMaskExpansion: undefined,
        holeSize: constants_1.DEFAULT_VIA_HOLE_SIZE,
        minHoleSize: "0.2mm",
        maxHoleSize: "6.3mm",
        connectedLayers: "All",
        minKeepOut: "net(0.5mm) polygon(0.5mm)",
    },
    smartVia: {
        keepOut: "250um", // 250microns = 0.25mm
        connectedLayers: "All",
        viaOptions: "All",
        rotation: "0deg",
    },
    net: {
        size: "10mil",
        fillStitchingDensity: "15mm",
        preferredTraceWidths: "150um 300um 500um",
        minKeepOut: "polygon(0.5mm)",
    },
    footprint: {
        stackup: constants_1.DEFAULT_FOOTPRINT_STACKUP_KEY,
    },
    text: {
        content: "= this.designator",
    },
    polygon: {
        minKeepOut: "net(0.5mm) polygon(0.5mm)",
        size: "8mm 4mm",
        connectedLayers: "All",
        fillStitchingDensity: "15mm",
        protected: `=shouldProtectPolygon(${constants_1.DEFAULT_POLYGON_PROTECTION_AREA_THRESHOLD})`, // Automatically protects small polygons (< 10% of layout area) from auto-layout modifications
    },
};
exports.ImpedanceRuleSheet = {
    "net[current]": {
        traceWidth: "=calculateTraceWidth()",
    },
    "net[impedance]": {
        traceWidth: "=calculateImpedanceTraceWidth()",
    },
    "net[impedancePair]": {
        keepOut: 'net[uid={{impedancePair}}]("=calculateImpedanceTraceKeepout()")',
        // Setting keep-in to 5x the trace width as a maximum but we will want to route
        // as close to keep-out as possible.
        keepIn: 'net[uid={{impedancePair}}]("=calculateImpedanceTraceWidth() * 5")',
    },
};
exports.NetTypeAutoLayoutPrioritySheet = {
    'net[NetType="Power"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.Power,
    },
    'net[NetType="High Speed"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.HighSpeed,
    },
    'net[NetType="Medium Speed"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.MediumSpeed,
    },
    'net[NetType="Low Speed"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.LowSpeed,
    },
    'net[NetType="Analog"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.Analog,
    },
    'net[NetType="Ground"]': {
        autoLayoutPriority: auto_layout_1.AutoLayoutPriority.GroundOrDefault,
    },
};
exports.GroundFillsV0RuleSheet = {
    "net[name=GND]": {
        connectedLayers: "All",
    },
};
//# sourceMappingURL=sheet.js.map